import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { UrgentManufacturingOrderBuilder } from '../../models/builders/urgent-manufacturing-order.builder';

const urgentManufacturingOrderBody = (
  hash: string,
  receivers: { hash: string; isRole: boolean; isUser: boolean }[],
  comment: string,
  date: number
) => ({
  manufacturingOrderHash: hash,
  comment: comment,
  receivers: receivers,
  date: date,
});

@Injectable()
export class UrgentManufacturingOrderApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}urgent-manufacturing-orders`;
  }

  saveUrgentManufacturingOrder(
    hash: string,
    receivers: { hash: string; isRole: boolean; isUser: boolean }[],
    comment: string,
    date: number
  ) {
    return this.httpClient
      .post(
        this.apiUrl,
        urgentManufacturingOrderBody(hash, receivers, comment, date)
      )
      .pipe(map(UrgentManufacturingOrderBuilder.fromJson));
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/urgent-manufacturing-order-api.service.ts